import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=5472e03d"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5472e03d')) {
      api.createRecord('5472e03d', component.options)
    } else {
      api.reload('5472e03d', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=5472e03d", function () {
      api.rerender('5472e03d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promo/settings.vue"
export default component.exports